// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1mjkt","content":"styles_content__1528s","checkbox":"styles_checkbox__2y0Ko","checkboxLabel":"styles_checkboxLabel__3--E2"};